module.exports = __webpack_public_path__ + "static/media/mbs_1.c07d8191.jpg";